export default "__VITE_ASSET__CyF2EmpC__"